<template>
    <div class="hzpProcess">
        <div class="processWrap">
            <div class="stepBlock" @click="goProcess(1)">
                <div class="stepImg">
                    <img src="@/assets/images/step1.png" alt="">
                </div>
                <div class="stepTitle">
                    第一步：创建备案信息
                </div>
                <div class="stepDesc">
                    进入“基础配置”-“备案信息”菜单,录入药监备案中的备案人/注册人、生成企业相关信息用于化妆品电子标签信息展示
                </div>
            </div>

            <!-- <img src="@/assets/images/splitLine.png" alt="" class="splitLine"> -->

            <div class="stepBlock" @click="goProcess(2)">
                <div class="stepImg">
                    <img src="@/assets/images/step2.png" alt="">
                </div>
                <div class="stepTitle">
                    第二步：创建产品信息
                </div>
                <div class="stepDesc">
                    进入“基础配置”-“产品信息”菜单，录入产品基本信息并关联对应的备案信息
                </div>
            </div>

            <!-- <img src="@/assets/images/splitLine.png" alt="" class="splitLine"> -->


            <div class="stepBlock" @click="goProcess(3)">
                <div class="stepImg">
                    <img src="@/assets/images/step3.png" alt="">
                </div>
                <div class="stepTitle">
                    第三步：创建产品页面
                </div>
                <div class="stepDesc">
                    进入"模板管理"-“模板列表”菜单，选择产品对应模板创建页面
                </div>
            </div>

            <!-- <img src="@/assets/images/splitLine.png" alt="" class="splitLine"> -->


            <div class="stepBlock" @click="goProcess(4)">
                <div class="stepImg">
                    <img src="@/assets/images/step4.png" alt="">
                </div>
                <div class="stepTitle">
                    第四步：创建标识码电子标签
                </div>
                <div class="stepDesc">
                    进入“模板管理”-“页面列表”选中对应页面进行“生成标识”操作
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
		name: "hzpProcess",
		components: {
			
		},
		data() {
			return {
				
			}
		},
		props: {
			
		},
		created() {
			
		},
		methods: {
			goProcess(step){
				if(step == 1){
					this.$router.push({
						path: '/crkConf/filingInof',
					})
				}else if(step == 2){
					this.$router.push({
						path: '/crkConf/production',
					})
				}else if(step == 3){
					this.$router.push({
						path: '/mkc/model',
					})
				}else if(step == 4){
					this.$router.push({
						path: '/mkc/page',
					})
				}
			}
		},
		mounted() {

		},
		beforeDestroy() {
			clearInterval(this.timer)
		}
	}
</script>

<style scoped lang="scss">
.hzpProcess{
    height: 100%;
    background-color: #f6f9fa;
    // padding: 20px;
    .processWrap{
        background-color: #fff;
        padding: 130px 20px 130px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: flex-start;
        .stepBlock{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 0 50px;
            position: relative;
            width: 360px;
            &::after{
                content: '';
                position: absolute;
                top: 20%;
                right: -40%;
                transform: translateY(-50%);
                width: 245px;
                height: 13px;
                background: url('../../../../assets/images/splitLine.png') no-repeat center center;
                background-size: 100% 100%;
                // background-color: #E5E5E5;
            }
            // &:nth-child(1):after{
            //     right: -16%;
            // }
            // &:nth-child(2):after{
            //     right: -28%;
            // }
            // &:nth-child(3):after{
            //     right: -45%;
            // }
            &:last-child::after{
                display: none;
            }
           .stepImg img{
                width: 118px;
                height: 118px;
                cursor: pointer;
           }
           .stepTitle{
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 20px;
                color: #272727;
                padding: 34px 0 17px;
           }
           .stepDesc{
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 16px;
                color: #787D83;
                line-height: 25px;
                text-align: center;
           }
        }
        // .splitLine{
        //     width: 120px;
        //     height: 8px;
        //     background-color: #E5E5E5;
        //     margin-top: 60px;
        // }
    }
}
</style>